import { renderBuildSortableHeaderDefTemplate } from '@next-adapter/templates/renderers/generators/sortable-header/build-sortable-header-def.js'
import { buildSortLabelExpr } from './build-sort-label-expr.js'
import { buildSortableHeaderButtonJsx } from './build-sortable-header-button-jsx.js'

export function buildSortableHeaderDef(
  headerText: string,
  options: { className?: string } = {}
): string {
  return renderBuildSortableHeaderDefTemplate({
    sortLabelExpr: buildSortLabelExpr(),
    sortableHeaderButtonJsx: buildSortableHeaderButtonJsx(headerText, options)
  })
}
